import {
  ADD_SCHOOL,
  ADD_SCHOOL_SUCCESS,
  ADD_SCHOOL_ERROR,

  GET_PROGRAMS,
  GET_PROGRAMS_SUCCESS,
  GET_PROGRAMS_ERROR,

  GET_FIELD_OF_STUDY,
  GET_FIELD_OF_STUDY_SUCCESS,
  GET_FIELD_OF_STUDY_ERROR,

  GET_CURRENCY,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_ERROR,

  GET_QUALIFICATION,
  GET_QUALIFICATION_SUCCESS,
  GET_QUALIFICATION_ERROR,

  GET_STUDY_LEVEL,
  GET_STUDY_LEVEL_SUCCESS,
  GET_STUDY_LEVEL_ERROR,

  GET_SCHOOL_FOS,
  GET_SCHOOL_FOS_SUCCESS,
  GET_SCHOOL_FOS_ERROR,

  ADD_SCHOOL_PROGRAM,
  ADD_SCHOOL_PROGRAM_SUCCESS,
  ADD_SCHOOL_PROGRAM_ERROR,

  DELETE_SCHOOL_PROGRAM,
  DELETE_SCHOOL_PROGRAM_SUCCESS,
  DELETE_SCHOOL_PROGRAM_ERROR,

  ADD_SCHOOL_FOS,
  ADD_SCHOOL_FOS_SUCCESS,
  ADD_SCHOOL_FOS_ERROR,

  DELETE_SCHOOL_FOS,
  DELETE_SCHOOL_FOS_SUCCESS,
  DELETE_SCHOOL_FOS_ERROR,

} from "../actions";

const INIT_STATE = {
  allStudents: [],
  programs: [],
  fosData: [],
  currencyData: [],
  qualificationData: [],
  studyLevelData: [],
  schoolFosData: [],
  addSchoolSuccess: false,
  isProgramSuccess: false,
  isSchoolProgramSuccess: "",
  isSchoolProgramDeleted: "",
  isSchoolFosAdded: "",
  isSchoolFosDeleted: "",
  error: ""
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case ADD_SCHOOL:
      return { ...state, loading: true, error: "" };
    case ADD_SCHOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        addSchoolSuccess: action.payload.student.meta.message,
        allStudents: action.payload.student.data,
      };
    case ADD_SCHOOL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case GET_PROGRAMS:
      return { ...state, loading: true, error: "" };
    case GET_PROGRAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        isProgramSuccess: action.payload.student.meta.message,
        programs: action.payload.student.data,
      };
    case GET_PROGRAMS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case GET_FIELD_OF_STUDY:
      return { ...state, loading: true, error: "" };
    case GET_FIELD_OF_STUDY_SUCCESS:
      return {
        ...state,
        loading: false,
        fosData: action.payload.student.data,
      };
    case GET_FIELD_OF_STUDY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case GET_CURRENCY:
      return { ...state, loading: true, error: "" };
    case GET_CURRENCY_SUCCESS:
      return {
        ...state,
        loading: false,
        currencyData: action.payload.student.data,
      };
    case GET_CURRENCY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case GET_QUALIFICATION:
      return { ...state, loading: true, error: "" };
    case GET_QUALIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        qualificationData: action.payload.student.data,
      };
    case GET_QUALIFICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case GET_STUDY_LEVEL:
      return { ...state, loading: true, error: "" };
    case GET_STUDY_LEVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        studyLevelData: action.payload.student.data,
      };
    case GET_STUDY_LEVEL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case GET_SCHOOL_FOS:
      return { ...state, loading: true, error: "" };
    case GET_SCHOOL_FOS_SUCCESS:
      return {
        ...state,
        loading: false,
        schoolFosData: action.payload.student.data,
      };
    case GET_SCHOOL_FOS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case ADD_SCHOOL_PROGRAM:
      return { ...state, loading: true, error: "" };
    case ADD_SCHOOL_PROGRAM_SUCCESS:
      return {
        ...state,
        loading: false,
        isSchoolProgramSuccess: "Program Added Successfully"
      };
    case ADD_SCHOOL_PROGRAM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case DELETE_SCHOOL_PROGRAM:
      return { ...state, loading: true, error: "" };
    case DELETE_SCHOOL_PROGRAM_SUCCESS:
      return {
        ...state,
        loading: false,
        isSchoolProgramDeleted: "Program Deleted Successfully"
      };
    case DELETE_SCHOOL_PROGRAM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case ADD_SCHOOL_FOS:
      return { ...state, loading: true, error: "" };
    case ADD_SCHOOL_FOS_SUCCESS:
      return {
        ...state,
        loading: false,
        isSchoolFosAdded: "Fos Added Successfully"
      };
    case ADD_SCHOOL_FOS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    case DELETE_SCHOOL_FOS:
      return { ...state, loading: true, error: "" };
    case DELETE_SCHOOL_FOS_SUCCESS:
      return {
        ...state,
        loading: false,
        isSchoolFosDeleted: "Fos Deleted Successfully"
      };
    case DELETE_SCHOOL_FOS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message.meta ? action.payload.message.meta.message : action.payload.message
      };

    default:
      return { ...state };
  }

};


